import { redirect, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/books/part/')({
  loader: () => {
    throw redirect({
      to: '/books/part/$partId',
      params: { partId: '6' },
    });
  },
});
